module.exports = __webpack_public_path__ + "static/media/home-process-2.f1f721b8.svg";